import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import Card from '../components/shared/Card.svelte';
import Button from '../components/shared/Button.svelte';
import Modal from '../components/shared/Modal.svelte';
import { createBackup, restoreBackup, downloadBlob } from '../lib/utils/backup';

import {
	exportSessionsCSV,
	exportDiapersCSV,
	exportWeightsCSV,
	exportStorageCSV
} from '../lib/utils/export';

import { getActiveChildren, getArchivedChildren, getActiveChildId } from '../lib/stores/children.svelte.ts';
import { showToast } from '../components/shared/Toast.svelte';

var root_1 = $.from_html(`<div class="section-content svelte-3eoefptjy08gx"><p class="hint svelte-3eoefptjy08gx">Create a full backup of all your data (all children) as a JSON file.</p> <!></div>`);
var root_3 = $.from_html(`<div class="section-content svelte-3eoefptjy08gx"><p class="hint svelte-3eoefptjy08gx">Restore from a backup file. This will replace all current data.</p> <label class="file-label svelte-3eoefptjy08gx"><input type="file" accept=".json" class="svelte-3eoefptjy08gx"/> Restore from Backup</label></div>`);
var root_5 = $.from_html(`<label class="check-row svelte-3eoefptjy08gx"><input type="checkbox"/> <span> </span></label>`);
var root_8 = $.from_html(`<label class="check-row archived svelte-3eoefptjy08gx"><input type="checkbox"/> <span> </span></label>`);
var root_6 = $.from_html(`<label class="check-row toggle-row svelte-3eoefptjy08gx"><input type="checkbox"/> <span>Include archived</span></label> <!>`, 1);
var root_4 = $.from_html(`<div class="children-checks svelte-3eoefptjy08gx"><!> <!></div> <div class="export-buttons svelte-3eoefptjy08gx"><!> <!> <!> <!></div>`, 1);
var root_13 = $.from_html(`<p style="margin-bottom:16px;color:var(--muted-fg);font-size:14px;">This will replace all existing data with the backup contents. This cannot be undone.</p> <div style="display:flex;gap:10px;"><!> <!></div>`, 1);
var root = $.from_html(`<!> <div class="export-page svelte-3eoefptjy08gx"><section class="svelte-3eoefptjy08gx"><h3 class="svelte-3eoefptjy08gx">Backup</h3> <!> <!></section> <section class="svelte-3eoefptjy08gx"><h3 class="svelte-3eoefptjy08gx">Export CSV — choose children</h3> <!></section></div> <!>`, 1);

function Export($$anchor, $$props) {
	$.push($$props, true);

	const activeList = $.derived(getActiveChildren);
	const archivedList = $.derived(getArchivedChildren);
	const activeId = $.derived(getActiveChildId);
	let selectedIds = $.state($.proxy(new Set()));
	let includeArchived = $.state(false);

	$.user_effect(() => {
		// Initialize selection to the active child once children load
		if ($.get(activeId) && $.get(selectedIds).size === 0) {
			$.set(selectedIds, new Set([$.get(activeId)]), true);
		}
	});

	function toggle(id) {
		if ($.get(selectedIds).has(id)) $.get(selectedIds).delete(id); else $.get(selectedIds).add(id);

		$.set(selectedIds, new Set($.get(selectedIds)), true);
	}

	let showRestoreConfirm = $.state(false);
	let restoreFile = $.state(null);

	async function handleBackup() {
		try {
			const blob = await createBackup();

			downloadBlob(blob, `mamaobaby-backup-${new Date().toISOString().split('T')[0]}.json`);
			showToast('Backup downloaded', 'success');
		} catch(e) {
			showToast('Failed to create backup. Please try again.', 'error');
		}
	}

	function handleFileSelect(e) {
		const input = e.target;

		if (input.files?.[0]) {
			$.set(restoreFile, input.files[0], true);
			$.set(showRestoreConfirm, true);
		}
	}

	async function handleRestore() {
		if (!$.get(restoreFile)) return;

		try {
			const text = await $.get(restoreFile).text();

			await restoreBackup(text);
			$.set(showRestoreConfirm, false);
			showToast('Data restored', 'success');
			setTimeout(() => window.location.reload(), 1000);
		} catch(e) {
			$.set(showRestoreConfirm, false);
			showToast('Failed to restore backup. File may be invalid.', 'error');
		}
	}

	function selectedArray() {
		return Array.from($.get(selectedIds));
	}

	async function exportSessions() {
		if ($.get(selectedIds).size === 0) {
			showToast('Select at least one child', 'error');

			return;
		}

		await exportSessionsCSV(selectedArray());
	}

	async function exportDiapers() {
		if ($.get(selectedIds).size === 0) {
			showToast('Select at least one child', 'error');

			return;
		}

		await exportDiapersCSV(selectedArray());
	}

	async function exportWeights() {
		if ($.get(selectedIds).size === 0) {
			showToast('Select at least one child', 'error');

			return;
		}

		await exportWeightsCSV(selectedArray());
	}

	async function exportStorage() {
		if ($.get(selectedIds).size === 0) {
			showToast('Select at least one child', 'error');

			return;
		}

		await exportStorageCSV(selectedArray());
	}

	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'Backup & Export', showBack: true, backPath: '/more' });

	var div = $.sibling(node, 2);
	var section = $.child(div);
	var node_1 = $.sibling($.child(section), 2);

	Card(node_1, {
		padding: 'md',
		children: ($$anchor, $$slotProps) => {
			var div_1 = root_1();
			var node_2 = $.sibling($.child(div_1), 2);

			Button(node_2, {
				variant: 'primary',
				fullWidth: true,
				onclick: handleBackup,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_1 = $.text('Create Backup');

					$.append($$anchor, text_1);
				},
				$$slots: { default: true }
			});

			$.reset(div_1);
			$.append($$anchor, div_1);
		},
		$$slots: { default: true }
	});

	var node_3 = $.sibling(node_1, 2);

	Card(node_3, {
		padding: 'md',
		children: ($$anchor, $$slotProps) => {
			var div_2 = root_3();
			var label = $.sibling($.child(div_2), 2);
			var input_1 = $.child(label);

			$.next();
			$.reset(label);
			$.reset(div_2);
			$.delegated('change', input_1, handleFileSelect);
			$.append($$anchor, div_2);
		},
		$$slots: { default: true }
	});

	$.reset(section);

	var section_1 = $.sibling(section, 2);
	var node_4 = $.sibling($.child(section_1), 2);

	Card(node_4, {
		padding: 'md',
		children: ($$anchor, $$slotProps) => {
			var fragment_1 = root_4();
			var div_3 = $.first_child(fragment_1);
			var node_5 = $.child(div_3);

			$.each(node_5, 17, () => $.get(activeList), (c) => c.id, ($$anchor, c) => {
				var label_1 = root_5();
				var input_2 = $.child(label_1);

				$.remove_input_defaults(input_2);

				var span = $.sibling(input_2, 2);
				var text_2 = $.child(span, true);

				$.reset(span);
				$.reset(label_1);

				$.template_effect(
					($0) => {
						$.set_checked(input_2, $0);
						$.set_text(text_2, $.get(c).name);
					},
					[() => $.get(selectedIds).has($.get(c).id)]
				);

				$.delegated('change', input_2, () => toggle($.get(c).id));
				$.append($$anchor, label_1);
			});

			var node_6 = $.sibling(node_5, 2);

			{
				var consequent_1 = ($$anchor) => {
					var fragment_2 = root_6();
					var label_2 = $.first_child(fragment_2);
					var input_3 = $.child(label_2);

					$.remove_input_defaults(input_3);
					$.next(2);
					$.reset(label_2);

					var node_7 = $.sibling(label_2, 2);

					{
						var consequent = ($$anchor) => {
							var fragment_3 = $.comment();
							var node_8 = $.first_child(fragment_3);

							$.each(node_8, 17, () => $.get(archivedList), (c) => c.id, ($$anchor, c) => {
								var label_3 = root_8();
								var input_4 = $.child(label_3);

								$.remove_input_defaults(input_4);

								var span_1 = $.sibling(input_4, 2);
								var text_3 = $.child(span_1, true);

								$.reset(span_1);
								$.reset(label_3);

								$.template_effect(
									($0) => {
										$.set_checked(input_4, $0);
										$.set_text(text_3, $.get(c).name);
									},
									[() => $.get(selectedIds).has($.get(c).id)]
								);

								$.delegated('change', input_4, () => toggle($.get(c).id));
								$.append($$anchor, label_3);
							});

							$.append($$anchor, fragment_3);
						};

						$.if(node_7, ($$render) => {
							if ($.get(includeArchived)) $$render(consequent);
						});
					}

					$.bind_checked(input_3, () => $.get(includeArchived), ($$value) => $.set(includeArchived, $$value));
					$.append($$anchor, fragment_2);
				};

				$.if(node_6, ($$render) => {
					if ($.get(archivedList).length > 0) $$render(consequent_1);
				});
			}

			$.reset(div_3);

			var div_4 = $.sibling(div_3, 2);
			var node_9 = $.child(div_4);

			Button(node_9, {
				variant: 'secondary',
				fullWidth: true,
				onclick: exportSessions,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_4 = $.text('Export Sessions');

					$.append($$anchor, text_4);
				},
				$$slots: { default: true }
			});

			var node_10 = $.sibling(node_9, 2);

			Button(node_10, {
				variant: 'secondary',
				fullWidth: true,
				onclick: exportDiapers,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_5 = $.text('Export Diapers');

					$.append($$anchor, text_5);
				},
				$$slots: { default: true }
			});

			var node_11 = $.sibling(node_10, 2);

			Button(node_11, {
				variant: 'secondary',
				fullWidth: true,
				onclick: exportWeights,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_6 = $.text('Export Weights');

					$.append($$anchor, text_6);
				},
				$$slots: { default: true }
			});

			var node_12 = $.sibling(node_11, 2);

			Button(node_12, {
				variant: 'secondary',
				fullWidth: true,
				onclick: exportStorage,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_7 = $.text('Export Storage');

					$.append($$anchor, text_7);
				},
				$$slots: { default: true }
			});

			$.reset(div_4);
			$.append($$anchor, fragment_1);
		},
		$$slots: { default: true }
	});

	$.reset(section_1);
	$.reset(div);

	var node_13 = $.sibling(div, 2);

	Modal(node_13, {
		get open() {
			return $.get(showRestoreConfirm);
		},
		onclose: () => $.set(showRestoreConfirm, false),
		title: 'Restore backup?',
		children: ($$anchor, $$slotProps) => {
			var fragment_4 = root_13();
			var div_5 = $.sibling($.first_child(fragment_4), 2);
			var node_14 = $.child(div_5);

			Button(node_14, {
				variant: 'secondary',
				fullWidth: true,
				onclick: () => $.set(showRestoreConfirm, false),
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_8 = $.text('Cancel');

					$.append($$anchor, text_8);
				},
				$$slots: { default: true }
			});

			var node_15 = $.sibling(node_14, 2);

			Button(node_15, {
				variant: 'danger',
				fullWidth: true,
				onclick: handleRestore,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_9 = $.text('Restore');

					$.append($$anchor, text_9);
				},
				$$slots: { default: true }
			});

			$.reset(div_5);
			$.append($$anchor, fragment_4);
		},
		$$slots: { default: true }
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Export = $.hmr(Export);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3eoefptjy08gx');
		Export[$.HMR].update(module.default);
	});
}

export default Export;

$.delegate(['change']);
import "bun-svelte:Export.svelte-3rb4xvxhyf54j-style.css";